<template>
  <div>
    <div class="banner">
      <img src="../../assets/wlwtms_banner.png" alt="">
    </div>
    <div class="section_w content">
      <div class="container" style="position: relative;z-index: 10">
        <div class="section_title left">
          <p>
            运输管理平台(TMS)系统主要功能
          </p>
          <aside>
            Features
          </aside>
        </div>
        <div class="row">
          <div class="col-md-3 col-sm-6 col-xs-6 index_content_card">
            <img src="../../assets/features_pic01.png" alt="">
            <div>
              <p class="text_ellipsis">
                终端数据采集
              </p>
              <div class="text">
                人员登录、认证货单号码扫描信息输入上传签字、货物拍照信息查询
              </div>
            </div>
          </div>
          <div class="col-md-3 col-sm-6 col-xs-6 index_content_card">
            <img src="../../assets/features_pic02.png" alt="">
            <div>
              <p class="text_ellipsis">
                互动导航
              </p>
              <div class="text">
                实时监控人员和车辆人车、人车位置互动
              </div>
            </div>
          </div>
          <div class="col-md-3 col-sm-6 col-xs-6 index_content_card">
            <img src="../../assets/features_pic03.png" alt="">
            <div>
              <p class="text_ellipsis">
                高效即时通讯
              </p>
              <div class="text">
                多方实现文本、语音的即时通讯，实时了解人员情况
              </div>
            </div>
          </div>
          <div class="col-md-3 col-sm-6 col-xs-6 index_content_card">
            <img src="../../assets/features_pic04.png" alt="">
            <div>
              <p class="text_ellipsis">
                定位及轨迹管理
              </p>
              <div class="text">
                实时了解车辆位置
                跟踪车辆行进线路
                车辆历史轨迹回放
              </div>
            </div>
          </div>
          <div v-if="show" class="col-md-3 col-sm-6 col-xs-6 index_content_card">
            <img src="../../assets/features_pic05.png" alt="">
            <div>
              <p class="text_ellipsis">
                工单管理
              </p>
              <div class="text">
                发布、汇报工作任务查看司机任务状态
              </div>
            </div>
          </div>
          <div v-if="show" class="col-md-3 col-sm-6 col-xs-6 index_content_card">
            <img src="../../assets/features_pic06.png" alt="">
            <div>
              <p class="text_ellipsis">
                电子围栏
              </p>
              <div class="text">
                设定车辆路线、车辆越界告警、提示
              </div>
            </div>
          </div>
        </div>
        <div class="text-center">
          <button class="btn" @click="show = !show">{{show? "折叠 &nbsp;&nbsp;&nbsp; ︽": "全部 &nbsp;&nbsp;&nbsp; ︾"}}</button>
        </div>
      </div>
    </div>
    <div class="section_w solve" style="padding-bottom: 0px">
      <div class="container" style="position: relative; z-index: 10">
        <div class="section_title right">
          <p>
            运输管理平台(TMS)行业解决方案和服务
          </p>
          <aside>
            SOLUTION
          </aside>
        </div>
        <div class="row">
          <div class="col-md-3 col-sm-6 col-xs-12">
            <div style="background: #f9f8f6">
              <img src="../../assets/solve_pic01.jpg" alt="">
              <h4>危险品物流</h4>
              <p>凡具有腐蚀性、自燃性、易燃性、毒害性、爆炸性等性质，在运输、装卸和储存保管过程中容易造成人身伤亡和财产损毁而需要特别防护的物品。</p>
            </div>
          </div>
          <div class="col-md-3 col-sm-6 col-xs-12">
            <div style="background: #fbe4c1">
              <h4>公路零担/干线运输</h4>
              <p>
                零担/干线运输区别与整车运输，将多家客户同一目的地的货物集合为一个整车进行运输。这种运输模式是在单一客户货量较小时最经济的一种，存在以下管理难点：运输成本：管理关键数据“真实油耗”和“行驶里程”；货物安全和运输安全；服务质量和运力资源。
              </p>
              <img src="../../assets/solve_pic02.jpg" alt="">
            </div>
          </div>
          <div class="col-md-3 col-sm-6 col-xs-12">
            <div style="background: #f9f8f6">
              <img src="../../assets/solve_pic03.jpg" alt="">
              <h4>集装箱运输</h4>
              <p>
                公路集装箱运输，把空运、水运及铁路运输连接起来，实现门到门的运输。公路集装箱运输已经成为集装箱运输的一个重要的组成部分。公路集装箱运输，多采用甩挂运输模式。集装箱要能够和挂车匹配，挂车要能够和拖车进行匹配。对箱体进行识别和追踪是公路集装运输的一大难点。</p>
            </div>
          </div>
          <div class="col-md-3 col-sm-6 col-xs-12">
            <div style="background: #fbe4c1">
              <h4>冷链物流解决</h4>
              <p>
                车辆在行驶中，常会出现部分司机为省油，关闭冷机现象。中途温度出现异常，需第一时间获知并补救。温度不是越低越好，需保证货物始终处于安全温度范围内。对于时效的考核，企业想实现自动化和标准化，减少人为干预。交接货环节容易出问题的地方，长时间的开门易导致货物温度升高。</p>
              <img src="../../assets/solve_pic04.jpg" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section_w Module" style="padding-bottom: 0px">
      <div class="container" >
        <div class="section_title left">
          <p>
            运输管理平台(TMS)-功能模块
          </p>
          <aside>
            Module
          </aside>
        </div>
      </div>
      <div class="module_c">
        <div class="container">
          <div class="row">
            <div class="col-lg-2 col-md-3 col-sm-4 col-xs-6">
              <img src="../../assets/module_jcxx_icon.png" alt="">
              <h5>基础信息</h5>
              <p>
                农场管理 <br>
                喷灌圈管理 <br>
                品种管理 <br>
                仓库管理 <br>
                样品箱管理 <br>
                货架管理 <br>
                分选平台 <br>
                卸车平台 <br>
                拖车管理 <br>
              </p>
            </div>
            <div class="col-lg-2 col-md-3 col-sm-4 col-xs-6">
              <img src="../../assets/module_yhxt_icon.png" alt="">
              <h5>用户系统</h5>
              <p>
                后台： <br>
                用户管理 <br>
                角色管理 <br>
                权限管理 <br>
                菜单管理 <br>
                App端： <br>
                用户维护 <br>
                角色维护 <br>
                权限维护 <br>
              </p>
            </div>
            <div class="col-lg-2 col-md-3 col-sm-4 col-xs-6">
              <img src="../../assets/module_jhys_icon.png" alt="">
              <h5>计划运输</h5>
              <p>
                收货计划 <br>
                运单记录 <br>
                卡车管理 <br>
                车队管理 <br>
                运输任务 <br>
                车辆监控 <br>
                轨迹回放 <br>
                异常订单 <br>
                消息提醒 <br>
              </p>
            </div>
            <div class="col-lg-2 col-md-3 col-sm-4 col-xs-6">
              <img src="../../assets/module_ccgl_icon.png" alt="">
              <h5>仓储管理</h5>
              <p>
                货架监控 <br>
                外购单 <br>
                采样管理 <br>
                股份报告 <br>
                库存管理 <br>
                检测模板 <br>
                外购合同 <br>
                抽样管理 <br>
              </p>
            </div>
            <div class="col-lg-2 col-md-3 col-sm-4 col-xs-6">
              <img src="../../assets/module_khdgl_icon.png" alt="">
              <h5>客户端管理</h5>
              <p>
                消息发送 <br>
                版本更新 <br>
                意见反馈 <br>
                在途跟踪 <br>
                语音播报 <br>
                运单信息 <br>
                手机定位 <br>
                扫一扫 <br>
              </p>
            </div>
            <div class="col-lg-2 col-md-3 col-sm-4 col-xs-6">
              <img src="../../assets/module_ysbbfx_icon.png" alt="">
              <h5>运输报表分析</h5>
              <p>
                运输报告 <br>
                仓储报告 <br>
                实时报告 <br>
                车辆分析 <br>
                里程分析 <br>
                品种统计 <br>
                地块统计 <br>
                时间统计 <br>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section_w function">
      <div class="container" style="position: relative;z-index: 10">
        <div class="section_title right">
          <p>
            运输管理平台(TMS)-整体功能
          </p>
          <aside>
            Overall function
          </aside>
        </div>
        <div class="row">
          <div class="col-md-7 col-xs-12">
            <p>
              通过4G网络+智能终端实现人员流程操作、车辆的定位、跟踪、任务异常处理，车辆拍照上传等，与后台管理系统实时信息交互。
            </p>
            <div class="row function_c">
              <div class="col-xs-6">
                <img src="../../assets/Overallunction_APP_icon.png" alt="">
                掌上app
              </div>
              <div class="col-xs-6">
                <img src="../../assets/Overallunction_ewm_cion.png" alt="">
                <span>
                  终端高清摄像头
                二维码识别
                </span>
              </div>
              <div class="col-xs-6">
                <img src="../../assets/Overallunction_gz_icon.png" alt="">
                定位跟踪
              </div>
              <div class="col-xs-6">
                <img src="../../assets/Overallunction_tpsc_icon.png" alt="">
                车辆拍照上传
              </div>

            </div>
          </div>
          <div class="col-md-5 col-xs-12">
            <img class="small_b" src="../../assets/Overallunction_pic.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="section_w " style="padding-bottom: 0px">
      <div class="container">
        <div class="section_title left">
          <p>
            运输环节
          </p>
          <aside>
            transport
          </aside>
        </div>
      </div>
      <div class="transport_big">
        <div class="container">
          <div class="row">
            <div class="col-xs-9 col-xs-offset-3">
              <div class="col-xs-4">
                <img src="../../assets/transport_pic01.png" alt="">
              </div>
              <div class="col-xs-4">
                <img src="../../assets/transport_pic02.png" alt="">
              </div>
              <div class="col-xs-4">
                <img src="../../assets/transport_pic03.png" alt="">
              </div>
              <div class="col-xs-4">
                <img src="../../assets/transport_pic04.png" alt="">
              </div>
              <div class="col-xs-4">
                <img src="../../assets/transport_pic05.png" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="transport_small">
        <div class="container">
          <div class="row">
            <p>
              车载行业终端 <br>
              位置互动 <br>
              GPRS网络、智能调度 <br>
              GPS定位导航 <br>
              GPRS网络 <br>
              轨迹回放、车辆定位 <br>
            </p>
            <div class="col-sm-4 col-xs-6">
              <img src="../../assets/transport_pic01.jpg" alt="">
            </div>
            <div class="col-sm-4 col-xs-6">
              <img src="../../assets/transport_pic02.jpg" alt="">
            </div>
            <div class="col-sm-4 col-xs-6">
              <img src="../../assets/transport_pic03.jpg" alt="">
            </div>
            <div class="col-sm-4 col-xs-6">
              <img src="../../assets/transport_pic04.jpg" alt="">
            </div>
            <div class="col-sm-4 col-xs-6">
              <img src="../../assets/transport_pic05.jpg" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section_w hardware">
      <div class="container" style="position: relative;z-index: 10">
        <div class="section_title right">
          <p>
            硬件组成部分
          </p>
          <aside>
            hardware
          </aside>
        </div>
        <div class="row">
          <div class="col-md-5 text-center">
            <img src="../../assets/hardware_pic.png" alt="">
            <p class="text-left">
              “TMS车辆卫士”是综合应用GPS/LBS定位、位移传感、低功耗等物联网技术推出的具备震动报警、定位跟踪、轨迹查询等多功能为一体的智能硬件。已获得中国移动授权认证。
            </p>
          </div>
          <div class="col-md-7">
            <h6>
              震动报警
            </h6>
            <p>
              车辆在终端设防状态下震动，终端上报告警信息到平台，平台向用户发送告警短信。
            </p>
            <h6>
              越界报警
            </h6>
            <p>
              终端在电量低于20%的情况下告警，要求及时充电或更换电池。
            </p>
            <h6>
              低电报警
            </h6>
            <p>
              车辆在设防状态下移动并越过平台设置的围栏范围（如300米），触发报警。
            </p>
            <h6>
              断电告警
            </h6>
            <p>
              当电摩车上终端的外接电源被切断时，终端发送告警信息。
            </p>
            <h6>
              定位跟踪
            </h6>
            <p>
              车辆被盗情况下，用户可以通过短信、手机客户端及Web方式对终端进行立即定位。
            </p>
            <h6>
              轨迹查询
            </h6>
            <p>
              用户可以通过手机客户端和Web方式查看车辆的历史行驶轨迹。
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="section_w" style="padding-bottom: 0px">
      <div class="container" style="position: relative;z-index: 10">
        <div class="section_title left">
          <p>
            客户收益
          </p>
          <aside>
            BENIFIT
          </aside>
        </div>
      </div>
      <div class="income">
        <div class="container income_big">
          <div class="t1">
            <h5>对于生产企业</h5>
            <p>降低管理成本、有效的管控生产计划、防范运输环节货物损失的风险。</p>
          </div>
          <div class="t2">
            <h5>对于库管员</h5>
            <p>提高管理水平，将生产管理的核心提升到产品质量上来，而非运输环节。</p>
          </div>
          <div class="t3">
            <h5>对于运输业主</h5>
            <p>有效降低运输管理成本带来额外订单量。</p>
          </div>
          <div class="t4">
            <h5>对于监管者</h5>
            <p>有效降低行业系统性风险，加大危险品运输、两客一危的监管力度。</p>
          </div>
          <div class="t5">
            <h5>对于库管员</h5>
            <p>提高仓库利用率、货物周转率、高效制定出入库计划。</p>
          </div>
        </div>
      </div>
    </div>
    <div class="section_w case">
      <div class="container">
       <div class="row">
         <div class="col-sm-4 col-xs-12">
           <img src="../../assets/case_pic01.png" alt="">
         </div>
         <div class="col-sm-4 col-xs-12">
           <img src="../../assets/case_pic02.png" alt="">
         </div>
         <div class="col-sm-4 col-xs-12">
           <img src="../../assets/case_pic03.png" alt="">
         </div>
         <div class="col-sm-4 col-xs-12">
           <img src="../../assets/case_pic04.png" alt="">
         </div>
         <div class="col-sm-4 col-xs-12">
           <img src="../../assets/case_pic05.png" alt="">
         </div>
         <div class="col-sm-4 col-xs-12">
           <img src="../../assets/case_pic06.png" alt="">
         </div>
       </div>
      </div>
    </div>

    <Footer/>
  </div>
</template>

<script>
  import Swiper from 'swiper'
  import Footer from '../../components/Footer'

  export default {
    name: 'Dashboard',
    data: function() {
      return {
        show: false
      }
    },
    components: {
      Footer
    },
    mounted() {
      new Swiper('.swiper-container', {
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        autoplay: {
          delay: 8000,
          disableOnInteraction: false,
        },
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
      });
    },
    props: {}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .btn:focus {
    outline: none;
  }
  .btn {
    border: 1px solid #fe9901;
    background: transparent;
    color: #fe9901;
    padding: 10px 30px;
    font-size: 1.8rem;
    display: inline-block;
  }
  .case {
    background: url("../../assets/tms_list_bg.png") no-repeat center;
    background-size: 100% 100%;
  }
  .case .row>div {
    margin-bottom: 30px;
  }
  .income_big .t1 {
    top: 13%;
    left: 3%;
    width: 20%;
  }
  .income_big .t2 {
    bottom: 25%;
    left: 1%;
    width: 21%;
  }
  .income_big .t3 {
    top: 14%;
    right: 12%;
  }
  .income_big .t4 {
    bottom: 32%;
    right: 0%;
    width: 20%;
  }
  .income_big .t5 {
    bottom: 4%;
    right: 16%;
  }
  .income_big >div {
    width: 22%;
    position: absolute;
  }
  .income_big h5 {
    font-weight: bold;
    color: #8c4c00;
    font-size: 2.8rem;
  }
  .income_big p {
    font-weight: normal;
    color: #8c4c00;
    font-size: 1.8rem;
  }
  .income {
    background: url("../../assets/income_bg.png") no-repeat center;
    background-size: 100% 100%;
    padding: 40px 0px;
  }
  .income_big {
    height: 550px;
    background: url("../../assets/income_pic.png") no-repeat center center;
    position: relative;
    background-size: 55%;
  }
  .hardware {
    background: url("../../assets/hardware_bg.png") no-repeat center;
    background-size: 100% 100%;
  }
  .hardware .row h6 {
    color: #fe9901;
    font-size: 2.6rem;
    font-weight: bold;
    line-height: 3rem;
  }
  .hardware .row img {
    margin-bottom: 40px;
    width: auto;
  }
  .hardware .row p {
    font-size: 1.8rem;
    color: #666;
  }
  .transport_small p {
    color: #fe9901;
    font-size: 2rem;
    font-weight: bold;
    text-align: center;
    line-height: 3rem;
    margin-bottom: 30px;
  }
  .transport_small {
    background: url("../../assets/module_bg.jpg") no-repeat center;
    background-size: 100% 100%;
    padding: 40px;
  }
  .transport_big {
    background: url("../../assets/module_bg.jpg") no-repeat center;
    background-size: 100% 100%;
    padding: 40px;
  }
  .transport_big .row {
    background: url("../../assets/transport_pic.png") no-repeat center top;
    padding-top: 200px;
    background-size: 100%;
  }
  .transport_small .row div  {
    margin-bottom: 30px;
  }
  .transport_big .row div div {
    margin-bottom: 30px;
  }
  img {
    width: 100%;
  }

  .index_content_card {
    margin-bottom: 30px;

  }

  .index_content_card p {
    color: #ff9900;
    font-size: 2.4rem;
    margin-bottom: 5px;
  }

  .index_content_card > div {
    padding: 15px;
    border-bottom: 3px solid #fe9901;
    background-color: #fff;
  }

  .index_content_card span {
    margin-top: 8px;
    color: #2c3e50;
    display: block;
  }

  .index_content_card .text {
    color: #2c3e50;
  }

  .index_content_card .text {
    height: 45px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .content {
    background: url("../../assets/content_bg.jpg") no-repeat center;
    background-size: 100% 100%;
    position: relative;
    z-index: 2;
  }

  .content:after {
    content: "";
    display: block;
    position: absolute;
    left: 0px;
    top: 0px;
    height: 100%;
    width: 100%;
    background-size: 32%;
    z-index: 1;
  }

  .solve {
    position: relative;
    background: url("../../assets/solve_bg.png") no-repeat center;
    background-size: 100% 100%;
  }

  .solve h4 {
    font-size: 2.6rem;
    margin: 0px;
    color: #333;
    padding: 30px 15px 15px;
  }

  .solve .row p {
    font-size: 1.8rem;
    color: #333;
    padding: 0px 15px 15px;
    margin: 0px;
  }

  .solve .row > div {
    margin-bottom: 30px;
  }
  .function {
    background: url("../../assets/features_bg.png") no-repeat center;
    background-size: 100% 100%;
  }
  .function img {
    width: auto;
  }
  .function .row p {
    font-size: 2rem;
    color: #666;
    line-height: 26px;
    margin-bottom: 5rem;
  }
  .function .row div {
    font-size: 2rem;
    color: #666;
    line-height: 26px;
  }
  .function_c>div {
    margin-bottom: 30px;
  }
  .function_c span {
    display: inline-block;
    width: 136px;
    vertical-align: middle;
  }
  .function .row div img {
    margin-right: 2rem;
  }
  .function .small_b {
    width: 100%;
  }
  .module_c {
    padding: 40px 0px;
    background: url("../../assets/module_bg.jpg") no-repeat center;
    background-size: 100% 100%;
    text-align: center;
  }

  .module_c img {
    width: auto;
  }

  .module_c h5 {
    font-weight: bold;
    color: #905701;
    font-size: 2.6rem;
    padding: 10px 0px;
  }

  .module_c .row > div {
    min-height: 460px;
  }

  .module_c p {
    font-weight: normal;
    color: #905701;
    font-size: 1.8rem;
    line-height: 28px;
  }

  .index_content_card:hover > div {
    background-color: #fe9901;
  }

  .index_content_card:hover p {
    color: #fff
  }

  .index_content_card:hover span {
    color: #fff
  }

  .index_content_card:hover .text {
    color: #fff
  }

  .program_card p {
    text-align: center;
    color: #8c4c00;
    font-size: 2.8rem;
    margin-bottom: 20px;
    font-weight: bold;
  }

  .program_card span {
    color: #8c4c00;
    font-size: 2rem;
    margin-bottom: 20px;
    display: block;
  }

  .program_card img {
    width: 100px;
  }

  @media (max-width: 991px) {
    .transport_big {
      display: none;
    }
  }

  @media (min-width: 992px) {
    .solve .row>div:first-child div {
      min-height: 470px;
    }
    .transport_small {
      display: none;
    }
  }

  @media (max-width: 768px) {

    .content:after {
      display: none;
    }


  }
</style>
